export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 11.5a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/><path d=\"M12 6.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 2.5a1 1 0 011 1v17a1 1 0 01-1 1H6a1 1 0 01-1-1v-17a1 1 0 011-1h12zm-11 17h10v-15H7v15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};